import { Button, Card, IconButton, Typography, Box } from "@mui/material";
import { alpha, styled, useTheme } from "@mui/material/styles";

export const CardStyle = styled(Card)(({ theme }) => ({
  // boxShadow: "none",
  backdropFilter: "blur(7px)",
  WebkitBackdropFilter: "blur(7px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.paper, 0.6),
  marginTop: "10px",
  minHeight: "300px",
  // boxShadow: theme.customShadows.z12,
  boxShadow: theme.customShadows.z16,
  boxShadow: "none",

  // [theme.breakpoints.up("lg")]: {},
  // transition: ` ${theme.transitions.create(["transform"], {
  //   duration: theme.transitions.easing.easeInOut,
  // })}`,
}));

export const SocialIconButtons = styled(IconButton)(({ theme }) => ({
  color: theme.palette.secondary.dark,
  boxShadow: theme.shadows[8],
  transition: ` ${theme.transitions.create(["box-shadow"], {
    duration: theme.transitions.easing.easeInOut,
  })}`,
  "&:hover": {
    background: "#FFF",
    boxShadow: theme.customShadows.secondary,
  },
}));
